/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';

import { AddIpWhiteListComponent } from './add-ip-white-list.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        DMCommonModule,
    ],
    declarations: [AddIpWhiteListComponent],
    exports: [AddIpWhiteListComponent],
})
export class AddIpWhiteListModule { }
